import React, { useState } from 'react';
import '../styles/Projects.css';
import stocko1 from '../WebPicture/Stocko.png';
import stocko2 from '../WebPicture/Stocko2.png';
import makeup from '../WebPicture/MakeMeUpzz.png';
import cinema from '../WebPicture/CineMajesty.png';
import egg from '../WebPicture/EggProject.png';

const Projects = () =>
{
  const topRowProjects = [
    { src: stocko1, name: 'Stocko', link: 'https://drive.google.com/file/d/1CONRo4VF_H3FhTQihR39OB1MGptoFW2I/view?usp=sharing' },
    { src: stocko2, name: 'Stocko with c#', link: 'https://drive.google.com/file/d/16Ii-RYWKDv3QXcxqdFvMvFNSJgK8G6gu/view?usp=sharing' },
    { src: makeup, name: 'MakeMeUpzz', link: 'https://drive.google.com/file/d/1lro4heUutjbVUaAXj-oIDjnfSSe5LTRL/view?usp=sharing' },
  ];

  const bottomRowProjects = [
    { src: cinema, name: 'CineMajesty', link: 'https://drive.google.com/file/d/1ZQvULmSWlYLSQ9STRQhO8iLMBwm5xuoF/view?usp=sharing' },
    { src: egg, name: 'EggStore', link: 'https://drive.google.com/file/d/1gN3aoFD8WPaetODfH3CDsS_9fTMlF-ea/view?usp=sharing' },
  ];

  const [topRowIndex, setTopRowIndex] = useState(0);
  const [bottomRowIndex, setBottomRowIndex] = useState(0);

  const nextTopProjects = () =>
  {
    setTopRowIndex((prevIndex) => (prevIndex + 2) % topRowProjects.length);
  };

  const prevTopProjects = () =>
  {
    setTopRowIndex((prevIndex) =>
      prevIndex === 0 ? topRowProjects.length - 2 : (prevIndex - 2 + topRowProjects.length) % topRowProjects.length
    );
  };

  return (
    <div className="right-sect">
      <div>
        <p className='tes'>My Projects:</p>
      </div>
      <div className='box'>
        <div className="right-top">
          <button className="arrow left-arrow" onClick={prevTopProjects}>
            &#8249;
          </button>
          <div className="project-box">
            <a href={topRowProjects[topRowIndex].link} target="_blank" rel="noopener noreferrer">
              <img src={topRowProjects[topRowIndex].src} alt={topRowProjects[topRowIndex].name} />
              <div className="project-name">{topRowProjects[topRowIndex].name}</div>
            </a>
          </div>
          <div className="project-box">
            <a href={topRowProjects[(topRowIndex + 1) % topRowProjects.length].link} target="_blank" rel="noopener noreferrer">
              <img src={topRowProjects[(topRowIndex + 1) % topRowProjects.length].src} alt={topRowProjects[(topRowIndex + 1) % topRowProjects.length].name} />
              <div className="project-name">{topRowProjects[(topRowIndex + 1) % topRowProjects.length].name}</div>
            </a>
          </div>
          <button className="arrow right-arrow" onClick={nextTopProjects}>
            &#8250;
          </button>
        </div>

        <div className="right-bottom">
          <div className="project-box">
            <a href={bottomRowProjects[bottomRowIndex].link} target="_blank" rel="noopener noreferrer">
              <img src={bottomRowProjects[bottomRowIndex].src} alt={bottomRowProjects[bottomRowIndex].name} />
              <div className="project-name">{bottomRowProjects[bottomRowIndex].name}</div>
            </a>
          </div>
          <div className="project-box">
            <a href={bottomRowProjects[(bottomRowIndex + 1) % bottomRowProjects.length].link} target="_blank" rel="noopener noreferrer">
              <img src={bottomRowProjects[(bottomRowIndex + 1) % bottomRowProjects.length].src} alt={bottomRowProjects[(bottomRowIndex + 1) % bottomRowProjects.length].name} />
              <div className="project-name">{bottomRowProjects[(bottomRowIndex + 1) % bottomRowProjects.length].name}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
